import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import UserAuth from './UserAuth';
import UserProfile from './UserProfile';

function AuthManager({ compact = false }) {
    const { currentUser, loading } = useAuth();

    if (loading) {
        return null; // AuthProvider już obsługuje loading state
    }

    if (!currentUser) {
        return <UserAuth compact={compact} />;
    }

    return <UserProfile compact={compact} />;
}

export default AuthManager;
